<ng-container *ngIf="formGroup">
    <div class="row">
        <app-form-field label="En-tête">
            <app-report-component-select-filter
                    [findAllService]="headerService"
                    [parentFormGroup]="formGroup"
                    parentFormControlName="headerReportComponentId"></app-report-component-select-filter>
        </app-form-field>
        <app-form-field label="Pied de page">
            <app-report-component-select-filter
                    [findAllService]="footerService"
                    [parentFormGroup]="formGroup"
                    parentFormControlName="footerReportComponentId"
            ></app-report-component-select-filter>
        </app-form-field>
        <app-form-field label="Signature">
            <app-report-component-select-filter
                    [findAllService]="signatureService"
                    [parentFormGroup]="formGroup"
                    parentFormControlName="signatureReportComponentId"></app-report-component-select-filter>
        </app-form-field>
    </div>
</ng-container>

